import { Directive, Input, OnDestroy, ViewChild } from '@angular/core';
import { NgbDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';

import { ngbDateToUTC } from '../utils';

@Directive()
export class DatePicker implements OnDestroy {
  /** to either show the calendar or the month picker */
  public hideCalendar = false;
  private emitMonthSelection = false;

  @Input() public minDate: Date;
  @Input() public maxDate: Date;
  @Input() public startDate: Date;

  /** When true, the date selection is emitted on month selection and the calendar is never shown */
  @Input() public set monthOnly(monthOnly: boolean) {
    this.hideCalendar = monthOnly;
    this.emitMonthSelection = monthOnly;
  }

  public get monthOnly() {
    return this.emitMonthSelection;
  }

  private monthSelect$$ = new Subject<string>();
  public monthSelect$ = this.monthSelect$$.asObservable();

  @ViewChild(NgbDatepicker, { static: true }) public datePicker: NgbDatepicker;

  public ngOnDestroy() {
    this.monthSelect$$.complete();
  }

  public navigate(numberOfMonths: number) {
    const { state, calendar } = this.datePicker;
    this.datePicker.navigateTo(
      calendar.getNext(state.firstDate, 'm', numberOfMonths),
    );
  }

  /**
   * Handles the selection of the month from the ui.
   * When the monthOnly input is set to true, navigates and emits monthSelect$
   * When the monthOnly is falsy, navigates the date picker to the selected month and hides the month picker
   * @param monthDate first day of the month
   */
  public monthSelected(month: string) {
    const monthDate = new Date(month);
    const targetNgbDate = {
      day: 1,
      year: monthDate.getFullYear(),
      month: monthDate.getMonth() + 1,
    };
    // updates the header of the navigation
    this.datePicker.navigateTo(targetNgbDate);
    if (this.monthOnly) {
      this.monthSelect$$.next(ngbDateToUTC(targetNgbDate));
    } else {
      this.hideCalendar = false;
    }
  }

  public toggleCalendar() {
    if (!this.monthOnly) {
      this.hideCalendar = !this.hideCalendar;
    }
  }
}
